/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SendLeadReferralResponse } from './SendLeadReferralResponse';
import {
    SendLeadReferralResponseFromJSON,
    SendLeadReferralResponseFromJSONTyped,
    SendLeadReferralResponseToJSON,
    SendLeadReferralResponseToJSONTyped,
} from './SendLeadReferralResponse';

/**
 * 
 * @export
 * @interface SendLeadReferral201Response
 */
export interface SendLeadReferral201Response {
    /**
     * 
     */
    data?: SendLeadReferralResponse;
}

/**
 * Check if a given object implements the SendLeadReferral201Response interface.
 */
export function instanceOfSendLeadReferral201Response(value: object): value is SendLeadReferral201Response {
    return true;
}

export function SendLeadReferral201ResponseFromJSON(json: any): SendLeadReferral201Response {
    return SendLeadReferral201ResponseFromJSONTyped(json, false);
}

export function SendLeadReferral201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SendLeadReferral201Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : SendLeadReferralResponseFromJSON(json['data']),
    };
}

export function SendLeadReferral201ResponseToJSON(json: any): SendLeadReferral201Response {
    return SendLeadReferral201ResponseToJSONTyped(json, false);
}

export function SendLeadReferral201ResponseToJSONTyped(value?: SendLeadReferral201Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': SendLeadReferralResponseToJSON(value['data']),
    };
}

